import React, {useState, useEffect} from "react";
import {Link} from 'react-router-dom';
import { postData,getData } from '../../config/api-connect';
import {  Table, Select, Spin, Input, Breadcrumb,
          Modal, Form, Tag,Button,Typography,Tooltip
       } from 'antd';
import moment from 'moment';
import { ArrowRightOutlined, HomeOutlined, UserOutlined,StarFilled,SearchOutlined,FilterFilled } from '@ant-design/icons';
import * as Styled from './style.js';
import Spinner from '../../components/spinner'
import {toProperCase} from '../../utils/stringUtil.js'
import {getSearchFilter} from '../../utils/filterHelper.jsx'

const CustomerFeedback = () => {
  const [form] = Form.useForm();
  var local_city = JSON.parse(localStorage.getItem('cityId'))
  var local_selectedVenueId = JSON.parse(localStorage.getItem('selectedVenueId'))
  if(!local_selectedVenueId){
    local_selectedVenueId = 'All'
  }

  const [loading, setLoading] = useState(true)
  const [isSaving, setIsSaving] = useState(false)
  const [feedbackData, setFeedbackData] = useState([])
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [filterStatus, setFilterStatus] = useState("Pending");
  const [expandedRows, setExpandedRows] = useState({});
  const [ratingOptions,setRatingOptions] = useState({})
  const [cityId, setCityId] = useState(local_city)
  const [selectedVenueId, setSelectedVenueId] = useState(local_selectedVenueId)
  const [searchText, setSearchText] = useState('');
  const [ratingSummary, setRatingSummary] = useState([])

  useEffect(()=> {
    getCustomerFeedbackData()
  },[])

  const calculateRatingSummary = (data) => {
    const summary = {
      5: 0,
      4: 0,
      3: 0,
      2: 0,
      1: 0
    };
    
    data.forEach(feedback => {
      if (feedback.status?.toLowerCase() === 'completed' && feedback.rating) {
        const rating = parseInt(feedback.rating);
        if (rating >= 1 && rating <= 5) {
          summary[rating] += 1;
        }
      }
    });
    
    return [
      { rating: '5 Stars', count: summary[5], starCount: 5 },
      { rating: '4 Stars', count: summary[4], starCount: 4 },
      { rating: '3 Stars', count: summary[3], starCount: 3 },
      { rating: '2 Stars', count: summary[2], starCount: 2 },
      { rating: '1 Star', count: summary[1], starCount: 1 },
    ];
  };

  const getCustomerFeedbackData = async () => {
    setLoading(true)
    try{
      const response = await getData(`/business/get_customer_feedback_for_buddies/?venue_id=${selectedVenueId}&city_id=${cityId}`)
      if (response.success && response.result) {
        setFeedbackData(response.result)
        setRatingOptions(response.rating_options)
        const calculatedRatingSummary = calculateRatingSummary(response.result);
        setRatingSummary(calculatedRatingSummary);
      }
    }
    catch(error) {
      console.log('Error while fetching customer feedback',error)
    }
    finally{
      setLoading(false)
    }
  }

  const handleActionClick = (record) => {
    setSelectedFeedback(record)

    form.setFieldsValue({
      rating: record.rating || null,
      comment: record.comment || '',
    });

    setIsModalVisible(true);
  }

  const handleModalClose = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleFormSubmit = async () => {
    try {
      const values = await form.validateFields();
      setIsSaving(true);

      const response = await postData(`/business/edit_customer_feedback/`, {
        feedback_id: selectedFeedback.id,
        ...values,
      });
      if (response.success) {
        handleModalClose();
        getCustomerFeedbackData();
      }
    } catch (error) {
      console.log("Error saving feedback", error);
    } finally {
      setIsSaving(false);
    }
  };

  const toggleExpand = (recordId) => {
    setExpandedRows(prev => ({
      ...prev,
      [recordId]: !prev[recordId]
    }));
  };

  const renderHeader = (title) => {
    return(
      <div style={{ textAlign: 'center', fontWeight: 'bold',textWrap:'nowrap' }}>{title}</div>
    )
  }  

  const filteredData = feedbackData
    .filter((item) => {
      if (filterStatus === "Pending")
        return item.status?.toLowerCase() === "pending";
      if (filterStatus === "Completed")
        return item.status?.toLowerCase() === "completed";
      return true;
    }).filter((item) => {
      if (!searchText) return true;
      return Object.values(item).some((val) =>
        String(val).toLowerCase().includes(searchText.toLowerCase())
      );
    });

  const getDropdownFilter = (dataIndex) => ({
    filters: [...new Set(filteredData.map(item => item[dataIndex]).filter(v => v))].map(v => ({ text: v, value: v })),
    onFilter: (value, record) => record[dataIndex] === value,
    filterIcon: (filtered) => <FilterFilled style={{ color: filtered ? '#1890ff' : '' }} />,
  });

  const getDateSorter = (dataIndex) => ({
    sorter: (a, b) => moment(a[dataIndex]).valueOf() - moment(b[dataIndex]).valueOf(),
  });

  const sampleData = filteredData[0] || {};

  const columns = filteredData.length > 0 ? [
    ...Object.keys(sampleData)
    .filter((a) => 
      filterStatus === "Pending" ? 
        !['id','rating','comment','collected_by'].includes(a)
      : 
        !['id','assigned_to','start_date','end_date','package'].includes(a)
    )
    .map((key) => ({
      title: renderHeader(toProperCase(key)),
      dataIndex: key,
      align: 'center',
      ...((key === 'customer' || key === 'mobile') ? getSearchFilter(key, toProperCase(key)) : {}),
      ...((key === 'venue' || key === 'assigned_to' || key === 'collected_by') ? getDropdownFilter(key) : {}),
      ...((key === 'start_date' || key === 'end_date')  ? getDateSorter(key) : {}),
      ...(key === 'rating' && {
        sorter: (a, b) => {
          const ratingA = a.rating !== null && a.rating !== undefined ? parseInt(a.rating) : 0;
          const ratingB = b.rating !== null && b.rating !== undefined ? parseInt(b.rating) : 0;
          return ratingA - ratingB;
        },
        defaultSortOrder: 'descend',
      }),
      render: (value,record) => {
          if (key === 'rating'){
            const stars = value !== null && value !== undefined ? parseInt(value) : 0;
            return (
              <div style={{ display: "flex", justifyContent: "center" }}>
                {Array.from({ length: 5 }).map((_, i) => (
                  <StarFilled
                    key={i}
                    style={{
                      color: i < stars ? "#faad14" : "#d9d9d9",
                      fontSize: 18,
                      marginRight: 2,
                    }}
                  />
                ))}
              </div>
            );
          }
          else if(key === 'comment') {
            if (!value) return "";
            const maxChars = 60;
            const totalChars = value.length;
            const isLong = totalChars > maxChars;
            const displayText = expandedRows[record.id]
              ? value
              : value.substring(0, maxChars) + (isLong ? "..." : "");
            return (
              <div style={{ maxWidth: 300, whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                <span>{displayText}</span>
                {isLong && (
                  <Button
                    type="link"
                    size="small"
                    style={{ padding: 0, marginLeft: 4 }}
                    onClick={() => toggleExpand(record.id)}
                  >
                    {expandedRows[record.id] ? "Read less" : "Read more"}
                  </Button>
                )}
              </div>
            );
          }
          else if(key === 'status') {
            const status = value?.toLowerCase();
            if (status === "pending") {
              return (
                <div 
                  style={{textWrap: 'nowrap',cursor: "pointer"}}
                  onClick={()=> handleActionClick(record)}
                >
                  <Tag color="gold">
                    Pending
                  </Tag>
                  <div style={{ fontSize: "12px", color: "#888" }}>(Tap to change)</div>
                </div>
              );
            }
            if (status === "completed") {
              return (
                <Tag color="green" style={{ cursor: "not-allowed", pointerEvents: "none" }}>
                  Completed
                </Tag>
              );
            }
          }
          return value
      },
    })),
  ]
    : [];

	return(
		<Spin spinning={loading} indicator={<Spinner />}>
			<Styled.MainContainer>
				<Styled.TopDiv>    
          <Breadcrumb style={{padding:'10px'}} >
            <Breadcrumb.Item>
              <Link to="/">
                <HomeOutlined />
              </Link>
            </Breadcrumb.Item>

            <Breadcrumb.Item>
                <UserOutlined />
                <span style={{paddingLeft:'5px'}}>Customer Feedback</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        </Styled.TopDiv>

        <Styled.Header>  
          <span> Customer Feedback</span>
        </Styled.Header>
        <div style={{ display: "flex", gap: "8px",padding: "12px 16px",justifyContent:'space-between' }}>
          <div style={{ display: "flex", gap: "8px"}}>
            {["Pending", "Completed"].map((status) => (
              <Button
                key={status}
                type={filterStatus === status ? "primary" : "default"}
                onClick={() => setFilterStatus(status)}
                style={
                  filterStatus === status
                    ? { backgroundColor: "rgb(2, 71, 92)", borderColor: "rgb(2, 71, 92)" }
                    : {}
                }
              >
                {status}
              </Button>
            ))}
          </div>
          <Input
            placeholder="Search..."
            prefix={<SearchOutlined />}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: "250px" }}
            allowClear
          />
        </div>

        {filterStatus === 'Completed' && ratingSummary.length > 0 && (
          <div style={{display:'flex',justifyContent:'center'}}>
            <Styled.RatingGraphDiv style={{marginBottom:'10px', padding: '12px 16px'}}>
              <Styled.GraphDivLabelDiv style={{textAlign:'center'}}>
                <Styled.LabelHeading style={{width:'100%'}}> Rating Summary </Styled.LabelHeading>
              </Styled.GraphDivLabelDiv>

              {loading ? (
                <div style={{ height: '120px',display: 'flex',alignItems: 'center',justifyContent: 'center' }}>
                  <Spin />
                </div>
              ) : (
                <div style={{maxWidth: '500px', width: '100%',margin: '0 auto',paddingTop: '8px'}}
                >
                  {ratingSummary
                    .map(item => ({
                      ...item,
                      starCount: parseInt(item.rating.split(' ')[0])
                    }))
                    .sort((a, b) => b.starCount - a.starCount)
                    .map((item) => {
                      const maxCount = Math.max(...ratingSummary.map(r => r.count));
                      const percentage = (item.count / maxCount) * 100;
                      
                      let barColor = '#52c41a'; 
                      if (item.starCount === 4) barColor = '#95de64';
                      else if (item.starCount === 3) barColor = '#ffd666';
                      else if (item.starCount === 2) barColor = '#ff9c6e';
                      else if (item.starCount === 1) barColor = '#ff7875';
                      
                      return (
                        <div 
                          key={item.rating}
                          style={{ display: "flex",alignItems: "center",gap: "10px",marginBottom: "8px"}}
                        >
                          <div style={{ display: "flex",alignItems: "center",minWidth: "80px", 
                                        gap: "2px",justifyContent: "flex-end"}}
                          >
                            {Array.from({ length: 5 }).map((_, i) => (
                              <StarFilled key={i} style={{color: i < item.starCount ? "#faad14" : "#d9d9d9",fontSize: "14px"}}/>
                            ))}
                          </div>
                          
                          <Tooltip 
                            title={`${item.starCount} stars: ${item.count} reviews`}
                            placement="top"
                            color="white"
                            overlayInnerStyle={{color: '#333',border: '1px solid #d9d9d9',boxShadow: '0 2px 8px rgba(0,0,0,0.1)'}}
                          >
                            <div style={{ flex: 1,height: "6px",backgroundColor: "#f0f0f0",borderRadius: "3px",
                                          overflow: "hidden",position: "relative",cursor: "pointer"}}
                            >
                              <div style={{width: `${percentage}%`,height: "100%",backgroundColor: barColor,
                                            transition: "width 0.3s ease",borderRadius: "3px"}} 
                              />
                            </div>
                          </Tooltip>
                          <span style={{ minWidth: "35px", textAlign: "right",fontWeight: 600,color: "#595959",fontSize: "13px"}}>
                            {item.count}
                          </span>
                        </div>
                      );
                    })}
                </div>
              )}
            </Styled.RatingGraphDiv>
          </div>
        )}
        <div>
          <div className="recordCount">{filteredData.length} records</div>
          <Table
            className="drill-down-table table_container"
            rowKey="id"
            columns={columns}
            dataSource={filteredData}
            pagination={false}
            key={filterStatus}
          />
        </div>
			</Styled.MainContainer>
      { selectedFeedback &&
        <Modal
          title={`Edit Customer Feedback - ${selectedFeedback?.customer}`}
          open={isModalVisible}
          onCancel={handleModalClose}
          onOk={handleFormSubmit}
          okText={isSaving ? 'Saving...' : 'Save'}
          okButtonProps={{ disabled: isSaving }}
          cancelButtonProps={{ disabled: isSaving }}
          confirmLoading={isSaving}
        >
          <Form form={form} layout="vertical">
            <div style={{ 
              marginBottom: 16, 
              padding: '12px 16px', 
              backgroundColor: '#f0f8ff', 
              borderRadius: 6,
            }}>
              <Typography.Text>
                {selectedFeedback?.package 
                  ? `${selectedFeedback.package} from ${selectedFeedback.start_date} to ${selectedFeedback.end_date}`
                  : "No package assigned"
                }
              </Typography.Text>
            </div>
            <Form.Item
              name="rating"
              label="Rating"
              rules={[{ required: true,message: "Please select a rating" }]}
            >
              <Select placeholder="Select rating">
                {ratingOptions && Object.entries(ratingOptions).map(([value,label]) => (
                  <Select.Option key={value} value={value}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <span>
                        {Array.from({ length: value }).map((_, i) => (
                          <StarFilled key={i} style={{ color: "#faad14" }} />
                        ))}
                      </span>
                      <span>{label}</span>
                    </div>
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="comment"
              label="Comment"
              rules={[{ required: false }]}
            >
              <Input.TextArea
                rows={4}
                placeholder="Enter additional comments"
                maxLength={500}
                showCount
              />
            </Form.Item>

          </Form>
        </Modal>
      }
		</Spin>
	)
}

export default CustomerFeedback;	